import React, { useState } from "react";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import CartWidget from "../../products/cart/CartWidget.jsx";
import LoginWidget from "../../login/LoginWidget.jsx";

import firebaseApp from "../../../firebase/Credentials.js";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

import "./Navbar.css";

const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);

export default function NavBar() {
  const [user, setUser] = useState(null);

  async function getRol(uid) {
    const docRef = doc(firestore, `usuarios/${uid}`);
    const snap = await getDoc(docRef);
    return snap.data()?.rol;
  }

  function setUserWithFirebaseAndRol(usuarioFirebase) {
    getRol(usuarioFirebase.uid).then((rol) => {
      setUser({
        uid: usuarioFirebase.uid,
        email: usuarioFirebase.email,
        rol,
      });
    });
  }

  onAuthStateChanged(auth, (usuarioFirebase) => {
    if (usuarioFirebase && !user) {
      setUserWithFirebaseAndRol(usuarioFirebase);
    }
    if (!usuarioFirebase) {
      setUser(null);
    }
  });

  return (
    <Navbar expand="lg" sticky="top" className="nav-grande2">
      <Container fluid className="px-5">

        {/* LOGO */}
        <Navbar.Brand as={Link} to="/">
          <img
            className="logotipoo"
            src={process.env.REACT_APP_NAVBAR}
            alt="Logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbarScroll" />

        <Navbar.Collapse id="navbarScroll">
          <Nav className="ms-auto align-items-center">

            <Nav.Link as={Link} to="/" className="Menu">
              Inicio
            </Nav.Link>

            <Nav.Link as={Link} to="/products" className="Menu">
              Productos
            </Nav.Link>

            <Nav.Link
              href="https://instagram.com/ciclopista"
              target="_blank"
              className="Menu"
            >
              Ir a @ciclopista
            </Nav.Link>

            <Nav.Link as={Link} to="/PageCart" className="Menu">
              <CartWidget />
            </Nav.Link>

            {user === null && (
              <Nav.Link className="Menu">
                <LoginWidget />
              </Nav.Link>
            )}

            {user && (
              <NavDropdown
                title="Cuenta"
                id="nav-dropdown"
                className="cuenta-dropdown"
              >
                <NavDropdown.Item as={Link} to="/ProfilePage">
                  Perfil
                </NavDropdown.Item>

                {user.rol === "admin" && (
                  <>
                    <NavDropdown.Item as={Link} to="/orders">
                      Administrador
                    </NavDropdown.Item>
                    {/* <NavDropdown.Item as={Link} to="/UserManager">
                      Roles
                    </NavDropdown.Item> */}
                  </>
                )}

                <NavDropdown.Divider />

                <NavDropdown.Item onClick={() => signOut(auth)}>
                  Cerrar Sesión
                </NavDropdown.Item>
              </NavDropdown>
            )}

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
